import { navigateToKnowledgeBaseArticle } from '../../navigation/actions/navigateToKnowledgeBaseArticle';
import { getIsUngatedForKBInWidget } from '../../widget-data/selectors/widgetDataSelectors';
import { updateIsOnSearchMode } from '../../visitor-widget/reducers/isOnSearchMode';
import { getUsageTracker } from '../../usage-tracking/usageTracker';
import { getCurrentView } from '../../current-view/selectors/getCurrentView';
import { getIsOnSearchMode } from '../../visitor-widget/selectors/getIsOnSearchMode';
export const handleArticleClick = (articleId, href, browserWindowHeight, searchTerm) => (dispatch, getState) => {
  const isUngatedForKBInWidget = getIsUngatedForKBInWidget(getState());
  const currentView = getCurrentView(getState());
  const lastSearchModeEnabled = getIsOnSearchMode(getState());
  if (isUngatedForKBInWidget) {
    dispatch(updateIsOnSearchMode(false));
  }
  const tracker = getUsageTracker();
  tracker.track('widget-interaction', {
    action: 'clicked-kb-article'
  });
  dispatch(navigateToKnowledgeBaseArticle({
    deepLink: href,
    hubSpotContentId: `${articleId}`,
    hubSpotContentTextFragment: ''
  }, browserWindowHeight, {
    view: currentView,
    searchTerm,
    lastSearchModeEnabled
  }));
};